<template>
  <div>
    <div class="login_bg">
      <div class="bg_box">
        <img class="bg_bg" src="img/login_bg.svg" alt="" />
        <img class="bg_img" src="img/login_img.svg" alt="" />
      </div>
      <div class="login_box">
        <div class="login_text">
          <div class="container">
            <div class="nav">
              <div class="logo">
                <img src="img/logo.png" alt="" />
              </div>
              <button class="home_btn" @click="gotoUrl('https://www.nthu.edu.tw/', true)">NTHU</button>
            </div>
            <div :class="['login', { 'no_links': linkListItems.length === 0 }]">
              <div class="title">
                <h1>National Tsing Hua University (NTHU)</h1>
                <p>International Student Application System</p>
              </div>
              <div class="mb-3 form_group">
                <label for="emailInput" class="form-label"
                  ><img src="img/login_email.svg" alt=""
                /></label>
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': errors.email }"
                  id="emailInput"
                  v-model="formData.email"
                  aria-describedby="emailHelp"
                  placeholder="Email"
                  @keyup.enter="handleLogin"
                />
                <div class="invalid-feedback" v-if="errors.email">
                  {{ errors.email }}
                </div>
              </div>
              <div class="mb-3 form_group">
                <label for="passwordInput" class="form-label"
                  ><img src="img/login_password.svg" alt=""
                /></label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': errors.password }"
                  id="passwordInput"
                  v-model="formData.password"
                  placeholder="Password"
                  @keyup.enter="handleLogin"
                />
                <div class="invalid-feedback" v-if="errors.password">
                  {{ errors.password }}
                </div>
              </div>
              <div class="btn_box">
                <button class="forgot_btn" @click="gotoForgetPassword">
                  Forget password？
                </button>
              </div>
              <button class="login_btn" @click="handleLogin" :disabled="isSubmitting">
                {{ isSubmitting ? 'Logging in...' : 'Login' }}
              </button>
              <div class="btn_box">
                <button @click="gotoRegister" class="register_btn">
                  Register
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.098"
                    height="12.098"
                    viewBox="0 0 12.098 12.098"
                  >
                    <g id="arrow" transform="translate(1.158 1.414)">
                      <line
                        id="_1"
                        data-name="1"
                        x2="9.526"
                        transform="translate(0 0)"
                        fill="none"
                        stroke="#4d167d"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                      <line
                        id="_2"
                        data-name="2"
                        x2="9.526"
                        transform="translate(9.525 0) rotate(90)"
                        fill="none"
                        stroke="#4d167d"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                      <line
                        id="_3"
                        data-name="3"
                        x2="13.109"
                        transform="translate(0.256 9.269) rotate(-45)"
                        fill="none"
                        stroke="#4d167d"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                </button>
              </div>
              <hr class="line" />
              <ul class="link_list">
                <li v-for="(item, index) in linkListItems" :key="index">
                  <a href="">
                    <div class="img_box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.098"
                        height="12.098"
                        viewBox="0 0 12.098 12.098"
                      >
                        <g id="arrow" transform="translate(1.158 1.414)">
                          <line
                            id="_1"
                            data-name="1"
                            x2="9.526"
                            transform="translate(0 0)"
                            fill="none"
                            stroke="#4d167d"
                            stroke-linecap="round"
                            stroke-width="2"
                          />
                          <line
                            id="_2"
                            data-name="2"
                            x2="9.526"
                            transform="translate(9.525 0) rotate(90)"
                            fill="none"
                            stroke="#4d167d"
                            stroke-linecap="round"
                            stroke-width="2"
                          />
                          <line
                            id="_3"
                            data-name="3"
                            x2="13.109"
                            transform="translate(0.256 9.269) rotate(-45)"
                            fill="none"
                            stroke="#4d167d"
                            stroke-linecap="round"
                            stroke-width="2"
                          />
                        </g>
                      </svg>
                    </div>
                    <p>{{ item.linkTitle }}</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer_box">
          <div class="container">
            <div class="box">
              <ul class="list">
                <li v-for="(item, index) in listItems" :key="index">
                  <img :src="item.src" />
                  <p>{{ item.text }}</p>
                </li>
              </ul>
              <div class="social_list">
                <a
                  v-for="(item, index) in socialItems"
                  :key="index"
                  :href="item.to"
                  :title="item.title + '(另開新視窗)'"
                  target="_blank"
                >
                  <img :src="item.src" :alt="item.title" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from '@/router';
import { RouterLink } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: "Home",
  components: {
  },
  data() {
    return {
      formData: {
        email: '',
        password: '',
      },
      errors: {
        email: '',
        password: '',
      },
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      linkListItems: [],
      listItems: [
        {
          src: require("/public/img/icon_email_p.svg"),
          text: "itc@my.nthu.edu.tw",
        },
        {
          src: require("/public/img/icon_phone_p.svg"),
          text: "+886-3-5162453",
        },
        {
          src: require("/public/img/icon_address_p.svg"),
          text: "Office of Global Affairs, National Tsing Hua University No. 101, Section 2, Kuang-Fu Road, Hsinchu, Taiwan 30013",
        },
      ],
      socialItems: [
        {
          to: "https://zh-tw.facebook.com/people/Global-Affairs-National-Tsing-Hua-University-%E5%9B%9B%E6%B5%B7%E5%90%8C%E6%96%B9/100057749195868/#",
          title: "fb",
          src: require("/public/img/icon_fb_p.svg"),
        },
        {
          to: "https://www.instagram.com/nthuoga/",
          title: "ig",
          src: require("/public/img/icon_ig_p.svg"),
        },
        {
          to: "https://www.youtube.com/channel/UCjaf371JsfFmBZ6e1vMl1Nw",
          title: "youtube",
          src: require("/public/img/icon_youtube_p.svg"),
        },
        {
          to: "https://www.threads.net/@nthuoga?xmt=AQGz5FeYM3l3MXlc41vArPNDdktfeqREq2lRYHQV44k9EqE",
          title: "threads",
          src: require("/public/img/icon_threads_p.svg"),
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  mounted() {
    // Check if already logged in
    if (this.isLoggedIn) {
      this.$router.push('/Profile');
    }
  },
  methods: {
    ...mapActions(['login', 'checkUserApplication']),
    validateForm() {
      let isValid = true;      
      if (!this.formData.email) {
        this.errors.email = 'Email is required';
        isValid = false;
      } else {
        this.errors.email = '';
      }      
      if (!this.formData.password) {
        this.errors.password = 'Password is required';
        isValid = false;
      } else {
        this.errors.password = '';
      }      
      return isValid;
    },
    async handleLogin() {
      // Clear previous messages
      this.successMessage = '';
      this.errorMessage = '';
      
      // Validate form
      if (!this.validateForm()) {
        await Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Please fill in all required fields',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        const result = await this.login({
          Account: this.formData.email,
          Password: this.formData.password,
        });
        
        // 根據 result.data.ok 判斷成功或失敗
        if (result.success) {
          // 登入成功後，檢查使用者申請狀態
          //const applicationResult = await this.checkUserApplication();
          
          let redirectPath = '/Profile'; // 預設導向 Profile
          
          // if (applicationResult.success && applicationResult.data) {
          //   // 根據 hasApplication 決定導向頁面
          //   if (applicationResult.data.hasApplication === false) {
          //     // 沒有申請表單，導向 Terms 頁面
          //     redirectPath = '/Terms';
          //   } else if (applicationResult.data.hasApplication === true) {
          //     // 已有申請表單，導向 Profile 頁面
          //     redirectPath = '/Profile';
          //   }
          // }
          
          Swal.fire({
            icon: 'success',
            title: 'Login Successful!',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didClose: () => {
              // 根據申請狀態導向不同頁面
              this.$router.push(redirectPath);
            }
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: result.message || 'Invalid email or password. Please try again.',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Unexpected Error',
          text: 'An unexpected error occurred. Please try again.',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        console.error('Login error:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    // gotoForm() {
    //   this.$router.push("/QualificationForm");
    // },
    gotoRegister() {
      this.$router.push("/Register");
    },
    gotoForgetPassword() {
      this.$router.push("/ForgetPassword");
    },
    gotoUrl: function (Url, Blank) {
      if (Blank) {
        window.open(Url, "_blank");
      } else {
        location.href = Url;
      }
    },
  },
};
</script>

